import * as q from '@/services/api/request/query';
import { encodePaginatableQuery, PaginatableQuery, Query } from '../../request';
import { encodeSortableQuery, SortableQuery } from '@/services/api/request/query';

export interface ChecklistQuery extends PaginatableQuery, SortableQuery {
  search: string;
  category: number[];
  status: number | null;
  conductibleBy?: number[];
  entityItem?: number[];
}

export const encodeChecklistQuery = (query: ChecklistQuery): Query => ({
  ...encodePaginatableQuery(query),
  search: q.string(query.search),
  category: q.numbers(query.category),
  status: q.nullableNumber(query.status),
  entityItem: query.entityItem ? q.numbers(query.entityItem) : '',
  conductibleBy: query.conductibleBy ? q.numbers(query.conductibleBy) : '',
  ...encodeSortableQuery(query),
});
